import React from 'react';
import getquotestyles from '../LeadForm/getquote.module.css';

function CorporateLandingTile({ heading, subheading, content }) {
  return (
    <div className={getquotestyles['card-banner-container']}>
      <div className={getquotestyles['corporate-card-container']}>
        <p className={getquotestyles['corporate-card-header']}>{heading}</p>
        <span className={getquotestyles['corporate-card-heading']}>{subheading}</span>
        {content.map((text, index) => (
          <div key={index}>
            <div className={getquotestyles['corporate-card-subheading-container']}>
              <div className={getquotestyles['corporate-dots']} />
              <span className={getquotestyles['corporate-subheading-text']}>{text.corporatetext}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CorporateLandingTile;
